import { Navigate } from "react-router-dom";
import useAuthStore from "../../store/auth.store";

// Route guard for the owner admin (/admin/*). Backend enforces real auth
// on every endpoint — this is defense-in-depth so non-superusers don't
// see the admin chrome flash before redirecting.
//
// Anyone not is_superuser bounces to /dashboard silently.
export default function RequireSuperuser({ children }) {
  const { user, isAuthenticated, loading } = useAuthStore();
  if (loading) return null;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (!user?.is_superuser) return <Navigate to="/dashboard" replace />;
  return children;
}
